export default "__VITE_ASSET__DBU4jSP5__"